/**
 * 백엔드 공통 응답 타입.
 *
 * 백엔드 common/response/ApiResponse.java 와 1:1로 대응한다.
 * 한쪽을 바꾸면 반드시 다른 쪽도 바꾼다.
 */

export interface ApiError {
  code: string;
  message: string;
}

export interface ApiResponse<T> {
  success: boolean;
  data: T | null;
  error: ApiError | null;
  /** 백엔드가 KST 기준으로 만든 LocalDateTime 문자열. 예: "2026-08-09T16:30:00" */
  timestamp: string;
}

/**
 * 정규화된 API 오류.
 *
 * 네트워크 단절, 서버 5xx, 백엔드가 내려준 실패 응답을 모두 이 한 가지 형태로 만든다.
 * 호출부가 axios 에러와 비즈니스 실패를 따로 처리하지 않아도 되게 하기 위함이다.
 */
export class ApiException extends Error {
  /** 백엔드 ErrorCode. 통신 자체가 실패했으면 자체 코드가 들어간다. */
  readonly code: string;

  /** HTTP 상태. 응답을 받지 못했으면 0. */
  readonly status: number;

  constructor(code: string, message: string, status: number) {
    super(message);
    this.name = 'ApiException';
    this.code = code;
    this.status = status;
  }

  /** 재시도해볼 만한 오류인지. 네트워크 문제나 서버 일시 장애면 true. */
  get isRetryable(): boolean {
    return this.status === 0 || this.status >= 500;
  }
}

/** 통신 자체가 실패했을 때 쓰는 코드. 백엔드 ErrorCode와 겹치지 않게 접두어를 다르게 뒀다. */
export const CLIENT_ERROR_CODES = {
  NETWORK: 'X001',
  TIMEOUT: 'X002',
  UNKNOWN: 'X999',
} as const;
